import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm, useFormState } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { VARIABLES } from "../../Constant";
import Swal from "sweetalert2";

const QualityCheckSelection = () => {
    const navigate = useNavigate();
    const delay_time = VARIABLES.delayTime;
    const [params, setParams] = useState(null);
    const [formData, setFormData] = useState(null);
    // react Hook form Props
    const {
        handleSubmit,
        formState: { errors },
        control,
        watch,
        setValue,
    } = useForm();

    const { isValid } = useFormState({
        control,
    });

    const currentItem = watch("item");

    const { useFetch: useFetchGeneric } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { useFetch: useFetchSamplePlaning } = useAPIQuery({
        key: "sample-planing-and-quantity",
        endpoint: "/api/sampling-plan/",
    });

    const {
        data: samplePlan,
        isError: samplePlanError,
        isLoading: samplePlanLoading,
        error: samplePlanErrorData,
        refetch: refetchSamplePlan,
    } = useFetchSamplePlaning({
        params: params,
        enabled: !!params,
    });

    const {
        data: genericData,
        isLoading: genericDataLoading,
        isFetching: fetchingGenericData,
    } = useFetchGeneric({
        params: { action: "quality-check" },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 0,
        gcTime: 0,
        retry: 3,
        keepPlaceholder: false,
        refetchOnReconnect: true,
    });

    console.log(genericData);
    const orderDropdown = useMemo(() => {
        if (!genericData || !currentItem) return [];
        console.log(currentItem);
        if (
            currentItem?.category?.toLowerCase() ===
            "Raw Material".toLowerCase()
        ) {
            return genericData?.batch
                ?.filter((po) => po?.po__item_id === currentItem?.id)
                ?.map((info) => ({
                    // One batch can hold receipts from several POs, so the
                    // option must be unique per batch + PO.
                    value: `${info.batch_id}:${info.po_id}`,
                    label:
                        info.batch__batch_number + " - " + info?.po__po_number,
                    batch_id: info.batch_id,
                    po_id: info?.po_id,
                }));
        } else if (
            currentItem?.category?.toLowerCase() === "WIP".toLowerCase() ||
            currentItem?.category?.toLowerCase() === "FG".toLowerCase()
        ) {
            return genericData?.daily_plan
                ?.filter((dp) => dp?.item__id === currentItem?.id)
                ?.map((info) => ({
                    value: info.id,
                    label: `${info.date} - ${info.machine__item__item_name} - ${info.daily_plan_code}`,
                }));
        } else {
            return [];
        }
    }, [currentItem, genericData]);

    console.log(currentItem);
    console.log(genericData);

    const onSubmit = (data) => {
        console.log(data);
        const itemCategory = data?.item?.category?.toLowerCase();
        const isRawMaterial = itemCategory === "raw material";
        setParams({
            q:
                isRawMaterial || itemCategory === "wip"
                    ? "Raw Material"
                    : "FG",
            c: "type_name",
            item_id: data?.item?.id,
            batch_for_qc: isRawMaterial ? "po" : "daily_plan",
            batch_id: isRawMaterial
                ? data?.daily_purchased_order?.batch_id
                : data?.daily_purchased_order?.value,
            ...(isRawMaterial && {
                po_id: data?.daily_purchased_order?.po_id,
            }),
        });
        refetchSamplePlan();
        setFormData(data);
    };

    useMemo(() => {
        if (samplePlanError) {
            Swal.fire({
                title: "Error!",
                text:
                    samplePlanErrorData?.response?.data?.results?.message ??
                    "Error performing item selection",
                icon: "error",
            });
        }
        if (
            samplePlan &&
            formData &&
            !samplePlanError &&
            samplePlan?.results?.data?.length !== 0
        ) {
            Swal.fire({
                title: "Success!",
                text: samplePlan?.results?.message,
                icon: "success",
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate("/sample-size", {
                        state: {
                            data: {
                                ...samplePlan?.results?.data?.[0],
                                ...formData,
                            },
                        },
                    });
                }
            });
        }
        if (samplePlan?.results?.data?.length === 0) {
            Swal.fire({
                title: "Error!",
                text: samplePlan?.results?.data?.message,
                icon: "error",
            });
        }
    }, [samplePlan, samplePlanError, formData]);

    useEffect(() => {
        setValue("daily_purchased_order", null);
    }, [currentItem]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Initiate QC </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Select Item
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={genericData?.item
                                                    ?.filter(
                                                        (i) =>
                                                            i?.category?.toLowerCase() ===
                                                                "Raw Material"?.toLowerCase() ||
                                                            i?.category?.toLowerCase() ===
                                                                "WIP"?.toLowerCase() ||
                                                            i?.category?.toLowerCase() ===
                                                                "FG"?.toLowerCase()
                                                    )
                                                    ?.map((info) => ({
                                                        value: info?.id,
                                                        label: info?.item_name,
                                                        ...info,
                                                    }))}
                                                isLoading={
                                                    genericDataLoading ||
                                                    fetchingGenericData
                                                }
                                                isClearable={true}
                                                id="select-forms-item"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="item"
                                        control={control}
                                    />
                                    {errors.item && (
                                        <span className="fs-8 text-danger">
                                            Item is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Daily plans / Batches
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={orderDropdown}
                                                // isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-daily-purchased-order"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="daily_purchased_order"
                                        control={control}
                                    />
                                    {errors.daily_purchased_order && (
                                        <span className="fs-8 text-danger">
                                            Daily Purchased Order is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {samplePlanLoading ? (
                                            <button
                                                type="button"
                                                id="button-typemaster-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-typemaster"
                                                disabled={!isValid}
                                            >
                                                Submit
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QualityCheckSelection;
